import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit'

import { API_STATUS } from '../types';
import type { RootState } from '../../app/store'

import { ACTION_TYPE_PARENT, fetchAllUsers } from './actions';
import { organizationUserSliceInitialState } from './types';


const INITIAL_STATE: organizationUserSliceInitialState = {
  allUsersList: [],
  status: API_STATUS.idle,
  isLoading: false,
  error: null
}

/* eslint-disable no-param-reassign */
export const organizationUserSlice = createSlice({
  name: ACTION_TYPE_PARENT,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchAllUsers.fulfilled, (state, action: PayloadAction<string[]>) => {
        state.status = API_STATUS.success
        state.allUsersList = action.payload;
      })
      .addCase(fetchAllUsers.pending, (state) => {
        state.status = API_STATUS.loading
      })
      .addCase(fetchAllUsers.rejected, (state, action: any) => {
        state.status = API_STATUS.failed
        // state.error = action?.error?.message
        state.error = action.payload
      })
  }
})
/* eslint-disable no-param-reassign */

export default organizationUserSlice.reducer;
